module.exports = __webpack_public_path__ + "img/Porto Apartment - 65 of 85.d65cb4a5.jpeg";